/**
 * 字典数据标签 i18n（后端 dictLabel 为中文，按 dictType + value 映射）
 */
const DICT_LABEL_KEYS = {
  sys_common_status: {
    '0': 'dict.sysCommonStatus.fail',
    '1': 'dict.sysCommonStatus.success'
  },
  sys_oper_type: {
    '0': 'dict.sysOperType.other',
    '1': 'dict.sysOperType.insert',
    '2': 'dict.sysOperType.update',
    '3': 'dict.sysOperType.delete',
    '4': 'dict.sysOperType.grant',
    '5': 'dict.sysOperType.export',
    '6': 'dict.sysOperType.import',
    '7': 'dict.sysOperType.forceLogout',
    '8': 'dict.sysOperType.genCode',
    '9': 'dict.sysOperType.clean'
  }
}

/**
 * @param {Array} options 字典选项（来自 dict.type[xxx]）
 * @param {string} dictType 字典类型
 * @param {Function} t vue-i18n $t
 */
export function translateDictOptions (options, dictType, t) {
  if (!options || !options.length) {
    return []
  }
  const keyMap = DICT_LABEL_KEYS[dictType]
  if (!keyMap) {
    return options
  }
  return options.map(item => {
    const i18nKey = keyMap[String(item.value)]
    if (!i18nKey) {
      return item
    }
    const label = t(i18nKey)
    if (label && label !== i18nKey) {
      return { ...item, label }
    }
    return item
  })
}

export default translateDictOptions
